import { h } from 'preact'
import { WidgetContext } from '../../context'
import { RedirectControl } from './RedirectControl'
import { RedirectControlService, RedirectControlServiceMock } from './service'
import { buildUrls } from './urls'

export function RedirectControlWrapper() {
    return <WidgetContext.Consumer>
        {context => {
            const {
                serverBase,
                http,
                clientId,
                debug,
                mockRedirectControl,
                registerService,
                accountUrl,
            } = context
            const urls = buildUrls({ serverBase, accountUrl })
            let service = new RedirectControlService(http, urls, clientId)
            if (mockRedirectControl) {
                service = new RedirectControlServiceMock(http, urls, clientId)
            }
            registerService('redirectControl', service)
            return <RedirectControl service={service} debug={debug} />
        }}
    </WidgetContext.Consumer>
} 